import { render, staticRenderFns } from "./dragHandleSmallIcon.vue?vue&type=template&id=c30d4d76&"
import script from "./dragHandleSmallIcon.vue?vue&type=script&lang=js&"
export * from "./dragHandleSmallIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports